import { useRecoilState } from "recoil";
import { backendDataAtom } from "recoil/atoms/backendDataAtom.js";
import { backendPost } from "services/dataService.js";
import { useSnackbar } from "notistack";
import { updateListItemState } from "./listStateHelpers.js";

export function usePaymentImportActions() {
  const [backendData, setBackendData] = useRecoilState(backendDataAtom);
  const { enqueueSnackbar } = useSnackbar();

  const state = backendData?.data ? backendData : { data: [], meta: {} };

  const setState = (data) => {
    setBackendData({
      type: "payment_imports",
      data: data,
    });
  };

  const createPaymentImport = async (form_data, options) => {
    form_data.api_version = "v2";

    const {
      label = "Zahlungimport erstellen",
      setIsLoading = () => {},
      setResult = () => {},
    } = options || {};

    await backendPost("data/payment-imports/upload", {
      label,
      toSend: form_data,
      enqueueSnackbar,
      setIsLoading,
      setResult: (res) => {
        updateListItemState(backendData, setBackendData, res.data);
        setResult(res);
      },
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };

  return {
    createPaymentImport,
    setState,
    state,
  };
}
